var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tk-button',_vm._g(_vm._b({staticClass:"tkRightArrowButton",attrs:{"disabled":_vm.disabled}},'tk-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('tk-right-arrow',{staticClass:"tkRightArrowButton_arrow"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }